import { useState, useEffect, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import styles from './style.module.scss';
import { Row, Col, Modal, Form, Select, Typography } from 'antd';
import { Button } from 'components';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import FormHelper from 'helpers/FormHelper';
import { useNavigate } from 'hooks/useNavigate';
import UIHelper from 'helpers/UIHelper';
import Radio from '../../../../../../../components/radio';
import uuid from 'react-uuid';
import { ActionModal } from 'components';

const EditModelModal = ({
  show = true,
  description,
  loading,
  form,
  premisionsModels,
  hadnleCreatePremission,
  handleSetValues,
  isEdit,
}) => {
  const { t } = useTranslation();
  const history = useNavigate();
  const { pathname } = useLocation();
  const { idModel } = useParams();
  const [saveModal, setSaveModal] = useState(false);

  const onFinish = useCallback(
    async (values) => {
      await hadnleCreatePremission(values, idModel);
      setSaveModal(false);
    },
    [idModel, hadnleCreatePremission],
  );

  const handleCancel = useCallback(() => {
    if (idModel) {
      history(UIHelper.getListRoute(pathname, 2));
    } else {
      history(UIHelper.getListRoute(pathname, 1));
    }
  }, [idModel, history, pathname]);

  const onFinishFailed = useCallback((errorInfo) => {
    console.log('Failed:', errorInfo);
  }, []);

  const onClickSave = useCallback(() => {
    if (!idModel) {
      form.submit();
    } else {
      setSaveModal(true);
    }
  }, []);

  const onSaveModalDescription = isEdit
    ? // eslint-disable-next-line
      t(
        'Cliccando salva, si applicano le modifiche a tutti gli utenti che hanno questo \
        template assegnato e verranno perse le personalizzazioni custom di tutti gli utenti \
        che hanno questo template',
      )
    : '';

  const modalOnSave = useMemo(
    () => (
      <ActionModal
        loading={loading}
        show={saveModal}
        title={t('Preset permessi')}
        description={onSaveModalDescription}
        yesBtnText={t('Salva')}
        noBtnText={t('Chiudi')}
        onClickOk={() => form.submit()}
        onCancel={() => setSaveModal(false)}
        type={'info'}
      />
    ),
    [saveModal, setSaveModal, form, loading, t, onSaveModalDescription],
  );

  useEffect(() => {
    if (idModel) {
      handleSetValues(idModel);
    }
  }, [idModel, handleSetValues]);

  return (
    <Modal width={600} visible={show} onCancel={handleCancel} footer={false}>
      <div className={styles.modalContent}>
        <div className={styles.title}>
          {isEdit ? t('Modifica') : t('Nuovo')}
        </div>
        <span className={styles.description}>{description}</span>

        <Row gutter={14} className={styles.row}>
          <Col span={24}>
            <Form
              form={form}
              name='basic'
              wrapperCol={{
                span: 24,
              }}
              initialValues={{
                permission_model_ids: '',
                approve: 'deny',
              }}
              layout={'vertical'}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
              onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
            >
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name={'access_type'}>
                    <Radio.Group>
                      <Radio value={'read'}>{t('Read')}</Radio>
                      <Radio value={'write'}>{t('Read and update')}</Radio>
                      <Radio value={'create'}>{t('Read and write')}</Radio>
                      <Radio value={'deny'}>{t('Deny')}</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Typography.Title level={4}>{t('Approva')}</Typography.Title>
                  <Form.Item name={'approve'}>
                    <Radio.Group>
                      <Radio value={'step1'}>{t('Step 1')}</Radio>
                      <Radio value={'step2'}>{t('Step 2')}</Radio>
                      <Radio value={'deny'}>{t('Deny')}</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label={t('Preset permessi')}
                    name='permission_model_ids'
                  >
                    <Select placeholder={t('Selezioni opzione')}>
                      <Select.Option value={''}>
                        {t('Selezioni opzione')}.
                      </Select.Option>
                      {premisionsModels.map((item) => {
                        const arr = [];
                        arr.push(
                          <Select.Option
                            key={uuid()}
                            value={JSON.stringify(
                              item.permission_models.map((i) => i.id),
                            )}
                          >
                            <Typography.Title level={5} strong>
                              {item.title}
                            </Typography.Title>
                          </Select.Option>,
                        );
                        item.permission_models.forEach((i) => {
                          arr.push(
                            <Select.Option key={uuid()} value={i.id}>
                              <span style={{ marginLeft: 16 }}>{i.title}</span>
                            </Select.Option>,
                          );
                        });
                        return arr;
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col>
            <Button
              loading={!isEdit && loading}
              onClick={onClickSave}
              width={'326px'}
              big
            >
              {isEdit ? t('Salva') : t('Aggiungere')}
            </Button>
          </Col>
        </Row>
        {isEdit && modalOnSave}
      </div>
    </Modal>
  );
};

EditModelModal.propTypes = {
  onClickOk: PropTypes.func,
  onCancel: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  description: PropTypes.string,
  yesBtnText: PropTypes.string,
  noBtnText: PropTypes.string,
  show: PropTypes.bool,
  type: PropTypes.oneOf(['delete', 'info']),
  loading: PropTypes.bool,
};

export default EditModelModal;
